/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Generatereport1Inputs */

const zh_learn_generatereport1 = /** @type {(inputs: Learn_Generatereport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成学习报告`)
};

const en_learn_generatereport1 = /** @type {(inputs: Learn_Generatereport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Report`)
};

const es_learn_generatereport1 = /** @type {(inputs: Learn_Generatereport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar informe`)
};

/**
* | output |
* | --- |
* | "Generate Report" |
*
* @param {Learn_Generatereport1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_generatereport1 = /** @type {((inputs?: Learn_Generatereport1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Generatereport1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_generatereport1(inputs)
	if (locale === "en") return en_learn_generatereport1(inputs)
	return es_learn_generatereport1(inputs)
});
export { learn_generatereport1 as "learn_generateReport" }